<template>
  <div>
    <div class="flex justify-between mb-10 space-x-20">
      <p class="font-serif text-3xl xl:leading-tight xl:text-5xl">
        {{ unitsData.locales.heading }}
      </p>

      <ul class="hidden space-x-5 xl:flex" v-if="floors && floors.length > 0">
        <li>
          <a
            href="#"
            @click.prevent="setTab('all')"
            class="relative p-3 text-sm tracking-wider uppercase transition duration-200 border border-white rounded-md  active:top-px hover:bg-white"
            :class="
              activeTab === 'all'
                ? 'border-opacity-100 bg-white text-brand-500'
                : 'border-opacity-25  hover:border-opacity-50 hover:bg-opacity-25'
            "
          >
            {{ unitsData.locales.all_floors }}
          </a>
        </li>
        <li v-for="(floor, index) in floors" :key="index">
          <a
            href="#"
            @click.prevent="setTab(floor)"
            class="relative p-3 text-sm tracking-wider uppercase transition duration-200 border border-white rounded-md  active:top-px hover:bg-white"
            :class="
              activeTab === floor
                ? 'border-opacity-100 bg-white text-brand-500'
                : 'border-opacity-25  hover:border-opacity-50 hover:bg-opacity-25'
            "
          >
            {{ unitsData.locales.floor }} {{ floor }}
          </a>
        </li>
      </ul>
    </div>

    <vue-good-table
      @on-row-click="formatLink"
      styleClass="vgt-table"
      :columns="columns"
      :rows="rows"
      :row-style-class="disableRow"
      :sort-options="{
        enabled: true,
        initialSortBy: [{ field: 'status', type: 'asc' }],
      }"
      :pagination-options="{
        enabled: true,
        mode: 'pages',
        perPage: this.perPage,
        position: 'bottom',
        dropdownAllowAll: false,
        setCurrentPage: this.setCurrentPage,
        nextLabel: this.unitsData.locales.next,
        prevLabel: this.unitsData.locales.back,
        ofLabel: this.unitsData.locales.of,
        pageLabel: this.unitsData.locales.page,
      }"
    >
      <template slot="table-row" slot-scope="props">
        <template v-if="props.column.field == 'number'">
          <template v-if="props.row.number">
            {{ props.row.number }}
          </template>
          <template v-else> - </template>
        </template>

        <template v-else-if="props.column.field == 'box'">
          <template v-if="props.row.box">
            {{ props.row.box }}
          </template>
          <template v-else> - </template>
        </template>

        <template v-else-if="props.column.field == 'floor'">
          <template v-if="props.row.floor">
            {{ props.row.floor }}
          </template>
          <template v-else> - </template>
        </template>

        <template v-else-if="props.column.field == 'liveable_area'">
          <template
            v-if="props.row.liveable_area && props.row.liveable_area !== 0"
          >
            {{ parseFloat(props.row.liveable_area) | numeral("0,0[.]00") }}
            m<sup>2</sup>
          </template>
          <template v-else> - </template>
        </template>

        <template v-else-if="props.column.field == 'plot_area'">
          <template v-if="props.row.plot_area && props.row.plot_area !== 0">
            {{ parseFloat(props.row.plot_area) | numeral("0,0[.]00") }}
            m<sup>2</sup>
          </template>
          <template v-else> - </template>
        </template>

        <template v-else-if="props.column.field == 'price'">
          <template
            v-if="
              !props.row.price_hidden &&
              props.row.status !== 'sold' &&
              props.row.status !== 'option' &&
              props.row.price > 0
            "
          >
            &euro; {{ parseFloat(props.row.price) | numeral("0,0[.]00") }}
          </template>
          <template v-else> - </template>
        </template>

        <template v-else-if="props.column.field == 'status'">
          <div
            v-if="props.row.status === 'available'"
            class="inline-block px-3 py-2 text-xs font-medium tracking-wider text-white uppercase rounded-md shadow  bg-danger-500"
          >
            {{ unitsData.locales.for_sale }}
          </div>
          <div
            v-else-if="props.row.status === 'option'"
            class="inline-block px-3 py-2 text-xs font-medium leading-loose tracking-widest uppercase "
          >
            {{ unitsData.locales.option }}
          </div>
          <div
            v-else-if="props.row.status === 'sold'"
            class="inline-block px-3 py-2 text-xs font-medium leading-loose tracking-widest uppercase "
          >
            {{ unitsData.locales.sold }}
          </div>
          <div
            v-else-if="props.row.status === 'under_contract'"
            class="inline-block px-3 py-2 text-xs font-medium leading-loose tracking-widest uppercase "
          >
            {{ unitsData.locales.under_contract }}
          </div>
        </template>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import axios from "axios";
import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";

const slugify = require("slugify");

export default {
  components: {
    VueGoodTable,
  },
  computed: {
    floors() {
      let floors = [];
      this.units.forEach((unit) => {
        if (unit.meta.location.floor) {
          floors.push(parseInt(unit.meta.location.floor, 10));
        }
      });
      if (floors.length > 0) {
        floors = floors
          .filter((value, index, self) => self.indexOf(value) === index)
          .sort((a, b) => a - b);
      }
      return floors;
    },
  },
  data() {
    return {
      activeTab: "all",
      unitsData: window.unitsData,
      columns: [],
      rows: [],
      units: [],
      setCurrentPage: 1,
      perPage: 10,
    };
  },
  methods: {
    setTab(tab) {
      if (tab === "all") {
        this.addRows(this.units);
      } else {
        let units = JSON.parse(JSON.stringify(this.units));
        units = units.filter(
          (value) => parseInt(value.meta.location.floor, 10) === tab
        );
        this.addRows(units);
      }
      this.activeTab = tab;
      this.setCurrentPage = 1;
    },
    disableRow(row) {
      return row.status !== "available" ? "is-disabled" : "";
    },
    formatLink(link) {
      const title = slugify(link.row.title, {
        lower: true,
        strict: true,
      });
      const url = link.row.permalink.split("/");
      let prefix = "";
      if (this.unitsData.lang === "nl") {
        prefix = "te-huur";
        if (link.row.negotiation === "sale") {
          prefix = "te-koop";
        }
      } else if (this.unitsData.lang === "fr") {
        prefix = "a-louer";
        if (link.row.negotiation === "sale") {
          prefix = "a-vendre";
        }
      }
      window.location = `/${this.unitsData.lang}/${prefix}/${url[5]}/${title}`;
    },
    addRows(data) {
      this.rows = [];
      data.forEach((estate) => {
        if (this.unitsData.unit_id !== estate.id) {
          let plotAreaSize = estate.meta.sizes.plot_area.size;
          if (estate.meta.sizes.plot_area.unit === "are") {
            plotAreaSize = estate.meta.sizes.plot_area.size * 100;
          }
          const column = {
            permalink: estate.permalink,
            number: estate.meta.location.number,
            box: estate.meta.location.box,
            floor: estate.meta.location.floor,
            liveable_area: estate.meta.sizes.liveable_area.size,
            plot_area: plotAreaSize,
            price: estate.meta.price.amount,
            price_hidden: estate.meta.price.hidden,
            status: estate.meta.estate.status,
            title: estate.meta.estate.title[this.unitsData.lang],
            negotiation: estate.meta.features.negotiation,
          };

          this.rows.push(column);
        }
      });
    },
    generateRows() {
      this.columns.push({
        label: this.unitsData.locales.number,
        field: "number",
        type: "number",
      });

      this.columns.push({
        label: this.unitsData.locales.box,
        field: "box",
        type: "number",
      });

      this.columns.push({
        label: this.unitsData.locales.floor,
        field: "floor",
        type: "number",
      });

      this.columns.push({
        label: this.unitsData.locales.living_area,
        field: "liveable_area",
        type: "number",
      });

      this.columns.push({
        label: this.unitsData.locales.surface_area,
        field: "plot_area",
        type: "number",
      });

      this.columns.push({
        label: this.unitsData.locales.price_value,
        field: "price",
        type: "number",
      });

      this.columns.push({
        label: this.unitsData.locales.status,
        field: "status",
      });

      this.columns.push({
        label: "Permalink",
        field: "permalink",
        hidden: true,
      });

      this.columns.push({
        label: "Price hidden",
        field: "price_hidden",
        hidden: true,
      });

      this.columns.push({
        label: "Title",
        field: "title",
        hidden: true,
      });

      this.columns.push({
        label: "Negotiation",
        field: "negotiation",
        hidden: true,
      });
    },
    getUnits() {
      axios
        .get(`/wp-json/v1/sweepbright/property/${this.unitsData.id}/units`)
        .then((response) => {
          this.units = response.data.meta;
          this.units = [
            ...new Map(
              this.units.map((item) => [item.meta.estate.id, item])
            ).values(),
          ];
          this.addRows(this.units);
        });
    },
  },
  mounted() {
    this.getUnits();
    this.generateRows();
  },
};
</script>
